import { QueryClient } from '@tanstack/react-query';
import { RealtimeEvent } from '@/context/RealtimeContext';
import { isSeasonStandingsKey, seasonKeys } from './seasonQueries';

const standingsEvents = new Set(['season.standings.updated', 'season.standings.synced']);

export const seasonStandingsEvent = (workspaceId: string, event: RealtimeEvent): number | undefined => {
  const resource = event.payload as { domain?: string; season?: number } | undefined;
  if (
    !workspaceId || event.workspace_id !== workspaceId || !standingsEvents.has(event.type)
    || resource?.domain !== 'season' || !Number.isSafeInteger(resource.season) || Number(resource.season) <= 0
  ) return undefined;
  return Number(resource.season);
};

export const invalidateSeasonStandings = (client: QueryClient, workspaceId: string, season: number): Promise<void> => client.invalidateQueries({
  queryKey: seasonKeys.all(workspaceId),
  predicate: query => isSeasonStandingsKey(query.queryKey, workspaceId, season),
});
